export default __webpack_public_path__ + "static/media/Project all included@3x.000dcb63.png";